import PropTypes from "prop-types";
import CommonFilterInput from "./CommonFilterInput";
import "./CommonFilters.css";
const CommonFilters = ({
  members = [],

  assignees,
  providers,
  pharmacies,
  programs,

  memberFilter = [],

  providerFilter = [],
  pharmacyFilter = [],

  programFilter = [],

  onMemberChange,
  onProviderChange,
  onPharmacyChange,

  onProgramChange,

  onSearch,
  isPharmacy = false,
  isProvider = false,
  onOpenDropdown,
  onLoadMoreOptions,
  loadingMap = {},
  hasMoreMap = {},
  autoPrefetch = true,
}) => {
  let assigneeOptions = Array.isArray(assignees) ? [...assignees] : [];
  if (!assigneeOptions.includes("Unassigned")) {
    const allIdx = assigneeOptions.findIndex(
      (opt) => opt.toLowerCase() === "all"
    );
    if (allIdx === -1) {
      assigneeOptions.unshift("Unassigned");
    } else {
      assigneeOptions.splice(allIdx + 1, 0, "Unassigned");
    }
  }

  return (
    <div className="common-filters">
      <CommonFilterInput
        label="Members"
        placeholder="Filter by Members"
        value={memberFilter}
        onChange={onMemberChange}
        options={Array.isArray(members) ? members : []}
        type="select"
        multiple={true}
        onSearch={onSearch}
        filterType="MEMBER"
        onOpen={onOpenDropdown}
        onLoadMore={onLoadMoreOptions}
        isLoading={loadingMap.MEMBER}
        hasMore={hasMoreMap.MEMBER}
        autoPrefetch={autoPrefetch}
      />

      {!isPharmacy && (
        <CommonFilterInput
          label="Provider"
          placeholder="Filter by Providers"
          value={providerFilter}
          onChange={onProviderChange}
          options={Array.isArray(providers) ? providers : []}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="PROVIDER"
          onOpen={onOpenDropdown}
          onLoadMore={onLoadMoreOptions}
          isLoading={loadingMap.PROVIDER}
          hasMore={hasMoreMap.PROVIDER}
          autoPrefetch={autoPrefetch}
        />
      )}

      {!isProvider && (
        <CommonFilterInput
          label="Pharmacy"
          placeholder="Filter by Pharmacies"
          value={pharmacyFilter}
          onChange={onPharmacyChange}
          options={Array.isArray(pharmacies) ? pharmacies : []}
          type="select"
          multiple={true}
          onSearch={onSearch}
          filterType="PHARMACY"
          onOpen={onOpenDropdown}
          onLoadMore={onLoadMoreOptions}
          isLoading={loadingMap.PHARMACY}
          hasMore={hasMoreMap.PHARMACY}
          autoPrefetch={autoPrefetch}
        />
      )}
      <CommonFilterInput
        label="Program"
        placeholder="Filter by Programs"
        value={programFilter}
        onChange={onProgramChange}
        options={Array.isArray(programs) ? programs : []}
        type="select"
        multiple={true}
        onSearch={onSearch}
        filterType="PROGRAM"
        onOpen={onOpenDropdown}
        onLoadMore={onLoadMoreOptions}
        isLoading={loadingMap.PROGRAM}
        hasMore={hasMoreMap.PROGRAM}
        autoPrefetch={autoPrefetch}
      />
    </div>
  );
};

export default CommonFilters;

CommonFilters.propTypes = {
  members: PropTypes.arrayOf(PropTypes.string),
  assignees: PropTypes.arrayOf(PropTypes.string),
  providers: PropTypes.arrayOf(PropTypes.string),
  pharmacies: PropTypes.arrayOf(PropTypes.string),
  programs: PropTypes.arrayOf(PropTypes.string),
  memberFilter: PropTypes.arrayOf(PropTypes.string),
  providerFilter: PropTypes.arrayOf(PropTypes.string),
  pharmacyFilter: PropTypes.arrayOf(PropTypes.string),
  programFilter: PropTypes.arrayOf(PropTypes.string),
  onMemberChange: PropTypes.func,
  onProviderChange: PropTypes.func,
  onPharmacyChange: PropTypes.func,
  onProgramChange: PropTypes.func,
  onSearch: PropTypes.func,
  isPharmacy: PropTypes.bool,
  isProvider: PropTypes.bool,
  onOpenDropdown: PropTypes.func,
  onLoadMoreOptions: PropTypes.func,
  loadingMap: PropTypes.object,
  hasMoreMap: PropTypes.object,
  autoPrefetch: PropTypes.bool,
};
